import { emptyLastModifier } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/LLMTrackerUtils";

import type { Prompt } from "./types";

export const firstStringLabelSorter =
    (getLabel: (prompt: Prompt) => string | undefined) =>
    (a: Prompt, b: Prompt, sortOrder?: string | null) => {
        const labelA = getLabel(a);
        const labelB = getLabel(b);
        if (labelA && labelB) {
            return labelA.localeCompare(labelB);
        }
        if (!labelA && !labelB) {
            return 0;
        }
        return (labelA ? -1 : 1) * emptyLastModifier(sortOrder);
    };

export const visibilityAndPromptSort = () => {
    return (a: Prompt, b: Prompt) => {
        const visibilityDiff = (a.visibility ?? 0) - (b.visibility ?? 0);
        if (visibilityDiff !== 0) {
            return visibilityDiff;
        }

        return (b.prompt ?? "").localeCompare(a.prompt ?? "");
    };
};

export const averagePositionSorter = (a: Prompt, b: Prompt, sortOrder?: string | null) => {
    const positionA = a.averagePosition;
    const positionB = b.averagePosition;
    const hasA = positionA != null;
    const hasB = positionB != null;

    if (hasA && hasB) {
        const positionDiff = positionA - positionB;
        if (positionDiff !== 0) {
            return positionDiff;
        }
        return (b.prompt ?? "").localeCompare(a.prompt ?? "");
    }
    if (!hasA && !hasB) {
        return 0;
    }

    return (hasA ? -1 : 1) * emptyLastModifier(sortOrder);
};
